var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowerVine3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2560 1440",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: 0,
    y1: 0,
    x2: 50,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#264d3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#5fae8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b2f0e3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m-267.41,211.85c92.59,-100 279.63,-146.3 348.15,-90.74c68.52,55.56 -50,166.67 -25.93,277.78c24.07,111.11 118.52,124.07 174.07,103.7c55.56,-20.37 101.85,-146.3 217.41,-117.41c115.56,28.89 71.48,156.3 262.22,204.44c190.74,48.15 366.67,18.52 439.63,-21.11c72.96,-39.63 182.59,-128.89 198.15,-220.37c15.56,-91.48 -19.26,-164.07 -106.3,-227.04c-87.04,-62.96 -188.89,-74.07 -281.48,-72.22c-92.59,1.85 -159.26,35.19 -201.85,124.07c-42.59,88.89 -38.89,155.56 -20.37,235.19c18.52,79.63 70.37,164.81 113.7,199.26c43.33,34.44 151.11,106.3 238.15,126.67c87.04,20.37 253.7,5.56 337.78,-84.07c84.07,-89.63 127.04,-182.59 224.07,-192.59c97.04,-10 138.15,102.59 342.59,109.26c204.44,6.67 336.3,-123.33 383.33,-218.52c47.04,-95.19 97.41,-273.33 98.15,-357.41c0.74,-84.07 -24.81,-108.52 -25.93,-477.78c-1.11,-369.26 -484.07,28.52 -485.19,29.63c-1.11,1.11 -217.41,204.44 -219.26,210c-1.85,5.56 -292.59,-11.11 -318.52,155.56c-25.93,166.67 79.63,353.7 235.93,367.78c156.3,14.07 167.78,-323.33 362.96,-205.56c195.19,117.78 -148.89,532.22 12.22,672.96c161.11,140.74 205.56,-111.11 348.89,-47.04c143.33,64.07 67.78,219.26 -74.07,301.85c-141.85,82.59 -291.48,10 -481.48,81.48c-190,71.48 -258.15,289.63 -457.41,300c-199.26,10.37 -343.33,-149.26 -440.74,-214.81c-97.41,-65.56 -284.07,-138.15 -472.22,-135.19c-188.15,2.96 -306.3,98.89 -407.41,185.19c-101.11,86.3 -341.48,176.67 -416.67,138.89c-75.19,-37.78 -65.56,-282.59 -64.81,-283.33c0.74,-0.74 162.22,-858.52 162.22,-858.52z",
    fill: "#000000",
    fillOpacity: 0,
    id: "svg_21",
    stroke: "#000000",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowerVine3);
export default __webpack_public_path__ + "static/media/followerVine3.1f06f94fc33b4d5af5021a7a1ec8c26e.svg";
export { ForwardRef as ReactComponent };